import i18n from 'i18next';
import truncate from 'lodash/truncate';

export default ({ breadcrumbs = [], currentLocation } = {}) => {
  const breadcrumbList = [
    {
      key: 'videos-home-page',
      text: i18n.t('videos'),
      path: '/student/videos',
    },
  ];

  breadcrumbs.forEach((parent) => {
    breadcrumbList.push({
      key: `breadcrumb-topic-${parent.id}`,
      text: truncate(parent.name, { length: 45 }),
      path: `/student/videos/topics/${parent.id}`,
    });
  });

  if (currentLocation) {
    return [
      ...breadcrumbList,
      {
        key: `breadcrumb-current-${currentLocation.id}`,
        text: truncate(currentLocation.name, { length: 45 }),
      },
    ];
  }

  return breadcrumbList;
};
